export default __webpack_public_path__ + "static/media/q21_v2.e0a48ea2.png";